module.exports = __webpack_public_path__ + "img/Bodice-Front-B5-Da-Eb.59881765.png";